import { render, staticRenderFns } from "./importDictionary.vue?vue&type=template&id=c0a9cab6&scoped=true"
import script from "./importDictionary.vue?vue&type=script&lang=js"
export * from "./importDictionary.vue?vue&type=script&lang=js"
import style0 from "./importDictionary.vue?vue&type=style&index=0&id=c0a9cab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a9cab6",
  null
  
)

export default component.exports